var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.heading || _vm.subHeading)?_c('div',{staticClass:"post-heading"},[(_vm.subHeading)?_c('h4',[_vm._v(_vm._s(_vm.subHeading))]):_vm._e(),(_vm.heading)?_c('h3',[_vm._v(_vm._s(_vm.heading))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }